export type PromptDialogType = {
    defaultConfirmLabel: string;
    defaultCancelLabel: string;
};
